import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { TextBlockData } from '../../entityTypes';

export const textblockCommands = defineCommands({
  'textblock.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<TextBlockData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type TextblockCommand = CommandsOf<typeof textblockCommands>;
